const {blank} = require ("./rubyRailsMethodsToJs");
const {image} = require ("./assets");
const articlesTempFilePath = "/tmp/articles/";
const articlesPath = "uploads/articles/";
const { INSIGHT_HOST } = require("../config/app-const");

const fileImgPath = (article, articleAssets) => (articlesTempFilePath + articleAssets[article.id].article_id + "/" + articleAssets[article.id].file);
const fileRelativePath = (article, articleAssets) => (articlesPath + articleAssets[article.id].article_id + "/" + articleAssets[article.id].file);

const canViewThumbnail = (article, article_assets) => !blank(article_assets[article.id]) && image(article_assets[article.id], articlesTempFilePath);

const insightExternalUrl = (coding_uid) => {
  if (!coding_uid) return null;

  return `${INSIGHT_HOST}/a/${coding_uid}`;
}

export { canViewThumbnail, fileImgPath, fileRelativePath, insightExternalUrl }


